import { useMemo } from 'react';
import styled from 'styled-components';
import { useCheckFilterButtonActive } from '../../../../../hooks/filter/useCheckFilterButtonActive';
import { FilterType, IFilter } from '../../../../../interfaces/Filter.interfaces';
import { Icon } from '../../../icon/Icon';

interface FilterButtonProps {
  filter: IFilter;
  onClick: () => void;
  filterType: FilterType;
}

export const FilterButton = ({ filter, onClick, filterType }: FilterButtonProps) => {
  const { isFilterButtonActive } = useCheckFilterButtonActive({ filter, filterType });

  const filterTitle = useMemo<string>(() => {
    if (filter.optionType === 'radio') {
      const selectedOption = filter.options.find((option) => option.isSelected);

      if (selectedOption) {
        return selectedOption?.optionNameForButton || selectedOption?.optionName;
      }
    }

    return filter.buttonTitle || filter.title;
  }, [filter]);

  return (
    <Container isActive={isFilterButtonActive} onClick={onClick}>
      <ButtonText isActive={isFilterButtonActive}>{filterTitle}</ButtonText>
      <Icon name={'AngleDown'} size={'Small'} fill={isFilterButtonActive ? '#FFFFFF' : '#898B94'} />
    </Container>
  );
};

const Container = styled.button<{ isActive: boolean }>`
  display: flex;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: var(--radius-round, 80px);
  background: ${(props) => (props.isActive ? '#505363' : '#f2f2f7')};
`;

const ButtonText = styled.div<{ isActive: boolean }>`
  color: ${(props) => (props.isActive ? '#FFF' : '#232429')};
  text-align: center;

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */

  white-space: nowrap;
`;
